import React from "react";
import PropTypes from "prop-types";
import CountUp from "react-countup";
import { CustomPie } from '../..';

import "./MainPie.scss";

const MainPie = ({ gradient, index, percentage }) => {
  return (
    <div className="main-pie">
      <CustomPie
        pieSize={110}
        gradient={gradient}
        percent={percentage}
        strokeWidth={13}
      />
      <CountUp
        className={
          percentage
            ? `main-pie__percentage main-pie__percentage--${index}`
            : "main-pie__percentage"
        }
        start={0}
        end={parseInt(percentage, 10)}
        duration={1.25}
        suffix="%"
        useEasing
      />
    </div>
  );
}

MainPie.propTypes = {
  failure: PropTypes.number,
  gradient: PropTypes.string,
  success: PropTypes.number
};

MainPie.defaultProps = {
  failure: 0,
  gradient: "",
  success: 0
};

export default MainPie;
